// Единый источник живых Valutes с ОДНИМ поллингом на все компоненты.
//
// Раньше HeaderRates.vue и CommissionCalculatorModal.vue независимо друг от
// друга поллили getValutes() каждые 30 сек своими отдельными таймерами —
// два несинхронизированных запроса вместо одного, и теоретически тикер и
// калькулятор могли на мгновение показывать разные курсы, если между их
// двумя запросами курс успевал обновиться на бэкенде. Здесь — общее
// реактивное состояние (Vue.observable) плюс подписка со счётчиком: фоновый
// поллинг идёт, пока есть хотя бы один подписчик, и останавливается, когда
// подписчиков не осталось.
import Vue from "vue";
import { getValutes } from "@/api";

const state = Vue.observable({
  valutes: [],
  loaded: false
});

const POLL_INTERVAL_MS = 30 * 1000;
let pollTimer = null;
let subscriberCount = 0;

async function fetchValutes(silent) {
  try {
    const { data } = await getValutes();
    if (data.status) state.valutes = data.result;
    state.loaded = true;
  } catch (error) {
    // silent — фоновый поллинг, не пробрасываем ошибку дальше (не спамим
    // тостами каждые 30 сек); не-silent вызовы (первая загрузка) решают
    // сами, как её показать.
    if (!silent) throw error;
  }
}

function scheduleNextPoll() {
  clearTimeout(pollTimer);
  pollTimer = setTimeout(async () => {
    await fetchValutes(true);
    if (subscriberCount > 0) scheduleNextPoll();
  }, POLL_INTERVAL_MS);
}

// Подписка на живые курсы — первый подписчик запускает немедленную загрузку
// и фоновый поллинг, последний отписавшийся его останавливает. Возвращает
// функцию отписки.
export function subscribeToLiveValutes() {
  subscriberCount += 1;
  if (subscriberCount === 1 && !pollTimer) {
    fetchValutes(true).then(scheduleNextPoll);
  }
  return function unsubscribe() {
    subscriberCount = Math.max(0, subscriberCount - 1);
    if (subscriberCount === 0) {
      clearTimeout(pollTimer);
      pollTimer = null;
    }
  };
}

// Форс-рефреш по требованию (например, при открытии калькулятора — нужны
// самые свежие курсы прямо сейчас, не дожидаясь ближайшего тика общего
// поллинга). Обновляет то же самое общее состояние, отдельного таймера не
// заводит.
export function refreshLiveValutes(silent) {
  return fetchValutes(silent);
}

export function getLiveValutesState() {
  return state;
}



// WEBPACK FOOTER //
// ./src/utils/liveValutes.js